import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth, rolesOf } from "@/context/AuthContext";
import { canVisit, homeFor } from "@/lib/nav";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading)
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );

  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  const mine = rolesOf(user);
  if (mine.includes("guard") && mine.length === 1 && location.pathname !== "/gate") return <Navigate to="/gate" replace />;
  if (roles && !roles.some((r) => mine.includes(r))) return <Navigate to="/" replace />;
  if (!canVisit(user, location.pathname)) return <Navigate to={homeFor(user)} replace />;
  return children;
}
